import React from 'react';
import { useTranslation } from 'react-i18next';
import { PagePanel, OutlineWarningIcon, Box } from 'edenred-ui';
import { EmptyState } from '@epi-shared/components';

export function TokenValidationFailed() {
  const { t } = useTranslation();

  return (
    <PagePanel>
      <Box
        mt={6}
        minHeight={600}
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
      >
        <EmptyState
          icon={<OutlineWarningIcon />}
          title={t('sign_up.token_validation_failed_heading')}
          description={t('sign_up.token_validation_failed_description')}
          btnText={t('sign_up.token_validation_failed_btn')}
          btnOnClick={() => window.location.reload()}
        />
      </Box>
    </PagePanel>
  );
}
